import axios from 'axios';

const API = axios.create({
  baseURL: '/api'
});

// Add token to requests
API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth
export const login = (credentials) => API.post('/auth/login', credentials);
export const getCurrentUser = () => API.get('/auth/me');

// Utilities
export const getUtilities = () => API.get('/utilities');

// Outlets
export const getOutlets = (utilityId) => 
  API.get('/outlets', { params: { utilityId } });
export const getOutlet = (id) => API.get(`/outlets/${id}`);

// Readings
export const createReading = (data) => {
  // Expect { readingValue, outletId, imageUrl }
  return API.post('/readings', {
    readingValue: data.readingValue,
    outletId: data.outletId,
    imageUrl: data.imageUrl || null
  });
};
export const getReadings = (outletId) => 
  API.get('/readings', { params: { outletId } });

// Admin
export const getAllReadings = (filters) => 
  API.get('/admin/readings', { params: filters });
export const exportAdminReadingsCSV = (filters) =>
  API.get('/admin/readings/csv', { params: filters, responseType: 'blob' });
export const getAllOutlets = () => API.get('/admin/outlets');
export const getStatistics = () => API.get('/admin/statistics');
export const createAdminUser = (data) => API.post('/admin/users', data);
export const getAdminUsers = () => API.get('/admin/users');

export default API;
